import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_GAM_SETUP_ORDERS } from './api/query'
import { Data, Variables } from './api/types'
import { GamSetupOrderSlice, UseGetGamSetupOrders } from './types'

export const useGetGamSetupOrders = (): UseGetGamSetupOrders => {
  const { workspaceId } = useWorkspaceParam()

  const { data, isLoading } = useQuery<Variables, Data, GamSetupOrderSlice[]>({
    options: {
      enabled: workspaceId !== undefined,
      select: ({ node: { gamSetupOrders } }: Data): GamSetupOrderSlice[] =>
        gamSetupOrders ? fromDTO(gamSetupOrders) : [],
    },
    query: GET_GAM_SETUP_ORDERS,
    variables: {
      workspaceId,
    },
  })

  return {
    gamSetupOrders: data ?? [],
    loading: isLoading,
  }
}
